/**
 * The custom scheme used to open the mobile app.
 * This is used to open the mobile app from the web app, an email, or even a text message.
 *
 * The mobile app will handle the custom scheme and open the correct page using deep linking.
 *
 * @example "sagete://new-timesheet"
 * @see https://developer.apple.com/documentation/xcode/defining-a-custom-url-scheme-for-your-app
 * @see https://developer.android.com/training/app-links/deep-linking
 */
export const MOBILE_CUSTOM_SCHEME = 'sagete';
//# sourceMappingURL=mobile.js.map